import RouteConstants from '@/features/router/RouteConstants';
import { useModalContext } from '@/hooks/useModalContext';
import { useHistory } from 'react-router-dom';
import { WhatsappTemplate } from '../../../types/whatsappTemplates';
import { DeleteWhatsappTemplateModal } from '../DeleteWhatsappTemplateModal';

export const useWhatsappTemplateListActions = () => {
  const history = useHistory();
  const { openModal } = useModalContext();

  const handleCreate = () => {
    history.push(RouteConstants.createWhatsappTemplate);
  };

  const handleEdit = (templateId: string) => {
    history.push(RouteConstants.editWhatsappTemplate.replace(':templateId', templateId));
  };

  const handleRequestDelete = (template: WhatsappTemplate) => {
    openModal({
      renderContent: DeleteWhatsappTemplateModal,
      renderContentProps: {
        template: { id: template.id, name: template.name },
      },
      dismissable: true,
      fullWidth: false,
      fullHeight: false,
    });
  };

  const handleTemplatesHubEdit = (actionType: 'edit' | 'delete') => {
    if (actionType === 'edit') {
      history.push(RouteConstants.whatsappTemplatesEditHub);
    } else {
      history.push(RouteConstants.whatsappTemplatesDeleteHub);
    }
  };

  return {
    handleCreate,
    handleEdit,
    handleRequestDelete,
    handleTemplatesHubEdit,
  };
};
